
import SidebarBottom from "../../../assets/filled/SidebarBottom.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SidebarBottomIcon({ className, dataTestid = "SidebarBottomIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SidebarBottom data-testid={dataTestid} className={classes} {...rest} />
  );
}
